import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import {Row, Col, ListGroup} from 'reactstrap';

import MagstimHistoryFields from './MagstimHistoryFields';

//import { MagstimColor } from './../Magstim.Color'

class MagstimHistoryChanges extends React.Component {

    constructor() {
        super();

        this.state = {
            name: ""
        };

    }

    getNamedValuePairs(data) {

        //console.log("changes getNamedValuePairs", data);

        return [
            { name: 'Time Used', value: data.timeUsed },
            { name: 'No. of Pulses', value: data.noPulses },
            { name: 'Power Output', value: data.powerOutput }
        ];
    }

    getDivider = (listItems, index) =>{

        if(null !== listItems && undefined !== listItems && null !== index && undefined !== index){
            if( listItems.length > 1 && index < listItems.length - 1){
                return  <hr className="solid ml-0 mr-0"></hr>;
            }
        }

        return <></>;
    }


    render() {

        const listItems = this.props.data.map((link) =>
            this.getNamedValuePairs(link)
        );

        //let pairs = this.getNamedValuePairs(this.props.data);
        //let pairs = this.getNamedValuePairs(this.props.data[0]);
        //console.log("pairs", listItems);

        return (
            <Wrapper className="col">

                <Row className="pt-2 pb-2">
                    <Col className="mt-4" >
                        <ListGroup className="ui-list">
                            {
                                Object.keys(listItems).map((key, index) => (
                                    <>
                                    <MagstimHistoryFields key={'MagstimHistory' + key} listitems={listItems[index]} col1Size={4} col2Size={8} />
                                    {this.getDivider(listItems, index)}
                                    </>
                                ))
                            }
                        </ListGroup>
                    </Col>
                </Row>

            </Wrapper>
        );
    }
}

MagstimHistoryChanges.propTypes = {
    index: PropTypes.number,
    data: PropTypes.array
};

MagstimHistoryChanges.defaultProps = {
    index: undefined,
    data: undefined
};


const Wrapper = styled.section`
        
    .solid {
        border-top: 1.5px solid white;
        margin-left: 18px;
        margin-right: 18px;
    }

    input[type=text] {
        box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
    }

`;

export default MagstimHistoryChanges;